import { Container, Title, Box, AppShell } from "@mantine/core";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CreateLicenciadaForm from "@/modules/licenciadas/components/create-licenciada-form";

/**
 *
 */
export default function LicenciadaInclusaoPage() {
  const navigate = useNavigate();
  const REDIRECT_DELAY_MS = 2000;

  const handleSuccess = useCallback(() => {
    setTimeout(() => {
      navigate("/licenciadas/lista", { replace: true });
    }, REDIRECT_DELAY_MS);
  }, [navigate]);

  const handleCancel = useCallback(() => {
    navigate("/licenciadas/lista");
  }, [navigate]);

  return (
    <AppShell padding="md">
      <Box h="100vh" style={{ overflow: "auto" }}>
        <Container size="lg" py="xl">
          <Title order={1} mb="xl" ta="center">
            Criar Nova Licenciada
          </Title>
          <CreateLicenciadaForm onSuccess={handleSuccess} onCancel={handleCancel} />
        </Container>
      </Box>
    </AppShell>
  );
}
